<template>
  <div class="agreement">
    <div class="content_box">
      <div class="agreement_content"
           v-html="content">
      </div>
    </div>
  </div>
</template>
    
    <script>
import { agreement_section } from '@/api/hw'
import { getSessionStorage } from '@/utils/stage'
export default {
  data() {
    return {
      content: '',
      configData: '',
      agreement_id: '',
      screenWidth: '',
      imgSrc: require('@/assets/images/top_bg1.png'),
    }
  },
  mounted() {
    window.onresize = () =>
      (() => {
        this.initScreen()
      })()
  },
  created() {
    // this.initScreen()
    this.init()
  },
  methods: {
    init() {
      let configData = JSON.parse(getSessionStorage('message'))
      const accountStorage = JSON.parse(getSessionStorage('accountStorage'))

      const data = {
        agreement_id: accountStorage.web_config.agreement_user_version,
        section: 2,
      }
      console.log(data, accountStorage)
      const msg = Object.assign(JSON.parse(JSON.stringify(configData)), data)
      agreement_section(msg).then((res) => {
        this.content = this.placechange(res.data.content)
      })
      //   } else {
      //     const data = {
      //       section_id: 3,
      //     }
      //     const msg = Object.assign(JSON.parse(JSON.stringify(configData)), data)
      //     agreement_section_id(msg).then((res) => {
      //       this.content = this.placechange(res.data.content)
      //     })
      //   }
    },
    placechange(data) {
      const content = data
        .replace(/<e>/g, '<div  style="width:100%;text-align:center;">')
        .replace(/<\/e>/g, '</div>')
        .replace(/<dt>/g, '<a style="color:blue;">')
        .replace(/<\/dt>/g, '</a>')
        .replace(/<red>/g, '<span style="color:red;">')
        .replace(/<\/red>/g, '</span>')
        .replace(/<b>/g, '<stong style=" font-weight: 700;color:#575757;">')
        .replace(/<\/b>/g, '</stong>')
        .replace(/\n/g, '</br>')
      return content
    },
    eventTemp(e) {
      //在判断事件目标节点的时候，考虑到兼容性应该统一转换成大写或小写进行判断
      if (e.target.localName.toLowerCase() === 'a') {
        // 通过判端目标节点以后，就能在这里对其进行操作啦。
        let id = e.target.getAttribute('data-href')
        console.log(e.target.getAttribute('data-href'))
        const msg = { code: 11, data: id }
        window.location = id
        appPostMessage(msg)
      }
    },
  },
}
</script>
    
    <style lang="less" scope>
// @media screen and(max-width:749px) {
.agreement {
  height: 90vh;
  overflow: auto;
  padding-bottom: 30/75rem;
  white-space: normal;
  word-break: break-all;
  .tabBar {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 80/75rem;
    background: url('../assets/images/top_bg1.1.png') no-repeat;
    background-size: cover;
    img {
      width: 280/75rem;
      height: auto;
      margin-left: 10px;
    }
  }
  .content_box {
    padding: 10/75rem;
    width: 90%;
    overflow: auto;
    min-height: 800px;
    font-size: 20/75rem;
    // background: #fff;
    // box-shadow: 0px 17/75rem 26/75rem 1px rgba(0, 0, 0, 0.07);
    box-sizing: border-box;
    margin: 0 auto;
    border-radius: 6/75rem;
    margin-top: 30px;
  }
  .agreement_content {
    font-size: 27/75rem;
    color: #353535;
    margin-bottom: 80px;
    a {
      color: blue;
      font-size: 20/75rem;
    }
  }
}
table {
  border: 1px solid #ccc;
  border-collapse: collapse;
  th,
  td {
    border: 1px solid #ccc;
    border-collapse: collapse;
    height: 30/75rem;
    line-height: 30/75rem;
    width: 20%;
  }
}
</style>